import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Dialog} from "primereact/dialog";
import axios from "axios";
import download from "js-file-download";
import moment from "moment";

import ProductionitemListComponent from "../productionitem/ProductionitemListComponent";
import ProjectproductListComponent from "./ProjectproductListComponent";
import ProjectproductFormComponent from "./ProjectproductFormComponent";

import ProjectitemListService from "../_services/project/ProjectitemListService";
import ProjectItemDownloadService from "../_services/project/ProjectItemDownloadService";
import ProjectitemSchemaService from "../_services/project/ProjectitemSchemaService";

const ProjectitemListComponent = (props) => {

  const {t} = props;

  const [projectitems, setProjectitems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'position',
    sortOrder: -1
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      window.App.setState({rerenderProjectitemList: false})
      ProjectitemListService(JSON.stringify(lazyParams), window.App.state.propsProject.id)
        .then(response => {
          setTotalRecords(response.data.total_item_count);
          setProjectitems(response.data.items);
          setLoading(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                tooltip="Módosítás" tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  window.App.setState({
                    sidebarProjectitemUpdate: true,
                    dialogProjectitem: true,
                    projectitemFormMethod: 'update',
                    projectitemRowData: rowData
                  })
                }}/>
        <Button icon="pi pi-download" className="  p-button p-mr-2"
                tooltip="Letöltés" tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  ProjectItemDownloadService(window.App.state.propsProject.id, rowData.id)
                    .then(response => {
                      window.App.toastShow('success', 'Sikeres letöltés!', '')
                      download(response.data, localStorage.getItem('networkName')
                        + '_'
                        +
                        rowData.projectName
                        + '_'
                        +
                        rowData.name
                        + '_'
                        + moment.utc(new Date()).local().format('YYYY-MM-DD HH:mm:ss')
                        + '.pdf')
                      setLoading(false)
                    })
                    .catch(error => {
                      window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                      setLoading(false)
                    })
                }}/>
        <Button icon="pi pi-clock" className="  p-button-info p-mr-2"
                tooltip="Munkaidő" tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  window.App.setState({
                    sidebarProjectitemSumList: true,
                    projectitemRowData: rowData
                  })
                }}
                />
        <Button icon="pi pi-copy" className=" p-mr-2"
                tooltip="Másolás" tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  if (window.confirm('A másolás megerősítésére van szükség!')) {
                    setLoading(true)
                    axios({
                      method: 'post',
                      url: process.env.REACT_APP_API_HOST + "/project/" + window.App.state.propsProject.id + "/items/" + rowData.id + "/copy",
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                        'App-Network': localStorage.getItem("networkId")
                      }
                    })
                      .then(response => {
                        setLoading(false)
                        window.App.setState({
                          rerenderProjectitemList: true
                        })
                      })
                      .catch(error => {
                        setLoading(false)
                        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                      })

                  }
                }}
        />
        {rowData && rowData.deleted_at_snapshot ? (
          <Button icon="pi pi-undo" className="p-button-sm p-button-success"
                  tooltip="Visszaállítás" tooltipOptions={{ position: 'left' }}
                  onClick={() => {
                    axios({
                      method: 'get',
                      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "/api/v2/project/" + window.App.state.propsProject.id + "/items/" + rowData.id + "/restore",
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                        'App-Network': localStorage.getItem("networkId")
                      }
                    })
                      .then(response => {
                        window.App.toastShow('success', t('success_restore'),);
                        loadLazyData();
                      })
                      .catch(error => {
                        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                      })
                  }}
          />
        ) : (
          <Button icon="pi pi-trash" className=" p-button-danger"
                  tooltip="Törlés" tooltipOptions={{ position: 'left' }}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      axios({
                        method: 'delete',
                        url: process.env.REACT_APP_API_HOST + "/project/" + window.App.state.propsProject.id + "/items/" + rowData.id,
                        params: {},
                        headers: {
                          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                          'App-Network': localStorage.getItem("networkId")
                        }
                      })
                        .then(response => {
                          setLoading(false)
                          window.App.setState({
                            rerenderProjectitemList: true
                          })
                        })
                        .catch(error => {
                          setLoading(false)
                          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                        })
                    }
                  }}
          />
        )}
      </React.Fragment>
    );
  }

  const [expandedRows, setExpandedRows] = useState(null);
  const rowExpansionTemplate = (data) => {
    return (
      <>
        <div className="p-ml-3">
          <h3 className={"p-mt-0 p-pt-0"}>Feladatok</h3>
          <ProductionitemListComponent projectitemId={data.id} projectitem={data} />
          <h3 className={"p-mt-0 p-pt-0"}>Alapanyagok</h3>
          <ProjectproductListComponent projectId={props.projectId} projectitemId={data.id} />
        </div>
      </>
    );
  }

  const [schemas, setSchemas] = useState([]);
  const schema = (rowData) => {
    if (schemas && schemas[0]) {
      let schema = schemas.filter(item => item.id === rowData.projectItemSchema)
      if (schema[0] && schema[0].name) {
        return schema[0].name
      }
    }
  }

  useEffect(() => {
    ProjectitemSchemaService()
      .then(response => {
        setSchemas(response.data)
      })
      .catch(error => {

      })

    loadLazyData();
  }, [lazyParams, window.App.state.rerenderProjectitemList === true])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>

        </div>
        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
          {/*{lazyParams && lazyParams.deleted === 1 ? (*/}
          {/*  <Button type="button" icon={"pi pi-eye-slash"}*/}
          {/*          onClick={() => {*/}
          {/*            let _lazyParams = lazyParams*/}
          {/*            delete lazyParams.deleted*/}
          {/*            setLazyParams(_lazyParams)*/}
          {/*            loadLazyData()*/}
          {/*          }}*/}
          {/*          className="p-button-danger"/>*/}
          {/*) : (*/}
          {/*  <Button type="button" icon={"pi pi-eye"}*/}
          {/*          onClick={() => {*/}
          {/*            setLazyParams({*/}
          {/*              ...lazyParams,*/}
          {/*              deleted: 1*/}
          {/*            })*/}
          {/*          }}*/}
          {/*          className="p-button-success"/>*/}
          {/*)}*/}
          <Button type="button" label="Tételek importálása" icon="pi pi-upload"
                  className="p-button-secondary p-ml-2"
                  onClick={() => {
                    window.App.setState({
                      dialogProjectitemImport: true,
                    })
                  }}
          />
          <Button type="button" label="Tétel hozzáadása" icon="pi pi-plus" className="p-button-success p-ml-2"
                  onClick={() => {
                    window.App.setState({
                      dialogProjectitem: true,
                      projectitemFormMethod: 'create',
                    })
                  }}
          />
        </div>
      </div>
      <DataTable size={localStorage.getItem('scale')}
        emptyMessage="Nincs találat."
        value={projectitems} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} 
        autoLayout={true}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
        dataKey="id"
        rowExpansionTemplate={rowExpansionTemplate}
        expandedRows={expandedRows}
        onRowExpand={(e) => {
          let id = e.data.id
          setExpandedRows({[id]: true})
          window.App.setState({
            valueProjectitemId: e.data.id
          })
        }}
      >
        <Column field="projectItemStatusName" header="Státusz" sortable></Column>
        <Column field="serial" header="Sorszám"></Column>
        <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
        <Column field="externalReference" header={t('externalReference')} sortable filter filterPlaceholder={t('externalReference')}></Column>
        <Column field="projectItemSchema" header={t('projectItemSchema')} sortable body={schema}></Column>
        <Column field="quantity" header="Mennyiség"></Column>
        <Column field="unitName" header="Egység"></Column>
        <Column field="unitPrice" header="Egységár"></Column>
        <Column field="hasSubcontractor" header="Alvállalkozó" sortable body={(rowData) => {
          return (
            <>
              {rowData.hasSubcontractor === true ? (
                <i className={"pi pi-check text-success"}></i>
              ) : (
                <i className={"pi pi-times text-danger"}></i>
              )}
            </>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
        <Column expander style={{width: '3em'}}/>
      </DataTable>
      <Dialog visible={window.App.state.dialogProjectproduct}
              style={{width: '750px'}}
              header="Új alapanyag"
              modal
              onHide={() => {
                window.App.setState({
                  dialogProjectproduct: false
                })
              }}>
        <ProjectproductFormComponent projectId={props.projectId} projectItemId={window.App.state.valueProjectitemId}
                                     initialValues={window.App.state.projectproductRowData}/>
      </Dialog>
    </>
  )
}
export default withTranslation('common')(ProjectitemListComponent);
